import React, { useState } from 'react';
import { MdContentCopy } from "react-icons/md";
import { IoCheckmark } from "react-icons/io5";

const CopyAccessIdButton = ({ accessId }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(accessId);
      setCopied(true);
      setTimeout(() => setCopied(false), 1000); // Reset message after 2 seconds
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <button
      onClick={handleCopy}
      className="text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors duration-200"
      title={copied ? 'Copied!' : 'Copy to clipboard'}
    >
      {copied ? (
        <IoCheckmark className="w-4 h-4 text-green-500 dark:text-green-800" />
      ) : (
        <MdContentCopy className="w-4 h-4" />
      )}
    </button>
  );
};

export default CopyAccessIdButton;